import React, { useState, useEffect } from 'react';
import { SingleCollapse } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import NormalIndicator from './normal-indicator';
import DetailIndicator from './detail-indicator';

export interface IIndicators{
    index: number;
    indicator: any;    
    status: any;
    screen?: string;
    name?: string;
    isDetail?: boolean;
	dataColumns: any;
    currentYear: any;
    saveTable: any;
    tableAlerts?: string;
    initialValidate: boolean;
}

const Indicator: React.FC<IIndicators> = (props: IIndicators) => {
    const [data, setData] = useState<any>([]);
	const [columns, setColumns] = useState([]);
    const [helpName, setHelpName] = useState('');

	const view: IFollowupSubproject = {
        state: {
            dataColumns: props.dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    const mainIndicatorTitle = presenter.followupLabels.get("mainStrategicLineTitle");
    const secondIndicatorTitle = presenter.followupLabels.get("secondaryStrategicLineTitle");
    const resultsIndicatorsTitle = presenter.followupLabels.get("outcomeIndicatorsTitle");
    const productIndicators = presenter.followupLabels.get("productIndicatorsTitle");

    const getIndicators = (ind: any) => {  
        if(!props.isDetail){
            const helpName = props.name == "mainIndicator" ? presenter.followupLabels.get("helpMainIndicator") : 
                            props.name == "secondIndicator" ? presenter.followupLabels.get("helpSecondIndicator") : 
                            props.name == "resultsIndicators" ? presenter.followupLabels.get("helpResultsIndicators") : "";
            setData(ind)
            setHelpName(helpName)
        }else{
            ind.data = ind.data.map((item: any) => {return {...item, selected: false}})
            setData(ind)
        }
	}

	const getColumns = () => { 
        let auxCol = [] 
        if(!props.isDetail){
            auxCol = presenter.getIndType1Columns(props.status, props.currentYear);
        }else{
            auxCol = presenter.getIndType2Columns(props.status, props.currentYear);
        }      
		setColumns(auxCol)
	}
    
    useEffect(() => {
		getIndicators(props.indicator);
	}, [props.indicator, props.status?.CodigoDimension]);

	useEffect(() => {
		if(props.dataColumns?._values?.length) getColumns();
	}, [props.dataColumns, props.status?.CodigoDimension, presenter.subProjectMonths, props.status?.EnEdicion]);
    
    if(!props.indicator || !props.status) return <></>

    return (
        <>
        {(!props.isDetail)
            ?
                <SingleCollapse
                    keepOpen={!!props.tableAlerts}
                    key={props.index}
                    title={data?.staticTitle}
                    description={data?.name}
                    isOpen={(props.tableAlerts === "All" || props.initialValidate || !presenter.tourIndSeen) ? true : false}>
                    <NormalIndicator
                        initialValidate={props.initialValidate}
                        index={props.index}
                        indicator={props.indicator}    
                        status={props.status}
                        screen={props.screen}
                        name={props.name}
                        isDetail={props.isDetail}
                        dataColumns={props.dataColumns}
                        currentYear={props.currentYear}
                        saveTable={props.saveTable}
                        tableAlerts={props.tableAlerts}
                        columns={columns}
                        data={data}
                        helpName={helpName}
                        gridTitle={props.name == "mainIndicator" ? mainIndicatorTitle : 
                        props.name == "secondIndicator" ? secondIndicatorTitle : 
                        props.name == "resultsIndicators" ? resultsIndicatorsTitle : ""}
                    />
                </SingleCollapse>
            :
                <SingleCollapse
                    keepOpen={!!props.tableAlerts}
                    key={props.index}
                    title={data?.staticTitle}
                    description={data?.name}
                    isOpen={(props.tableAlerts === "All" || props.initialValidate || !presenter.tourIndSeen) ? true : false}>
                    <DetailIndicator
                        initialValidate={props.initialValidate}
                        index={props.index}
                        indicator={props.indicator}    
                        status={props.status}
                        screen={props.screen}
                        name={props.name}
                        isDetail={props.isDetail}
                        dataColumns={props.dataColumns}
                        currentYear={props.currentYear}
                        saveTable={props.saveTable}
                        tableAlerts={props.tableAlerts}
                        columns={columns}
                        data={data}
                        helpName={helpName}
                        gridTitle={productIndicators}
                    />
                </SingleCollapse>
        }
        </>
    )
}

export default Indicator;